<template>
  <div id="DeptTree">
    <div class="deptTreeTitle">组织结构树</div>
    <div class="deptTreeButton">
      <el-button class="eb-button-red" @click="addDept">新增</el-button>
      <el-button class="eb-button-red" @click="editDept" :disabled="isDisabled">修改</el-button>
      <el-button class="eb-button-red" @click="deleteDept" :disabled="isDisabled">删除</el-button>
    </div>
    <div class="deptTreeData">
      <ul>
        <li v-for="depart in departData" :key="depart.departId" :class="{selected:selectedDept.departId===depart.departId}" @click="selectDept(depart)">
          <span v-if="depart.departId!==orgId">&emsp;{{depart.departName}}({{depart.userCount}})</span>
          <span v-else>{{depart.departName}}({{depart.userCount}})</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
import { loadDepartment, loadDepartmentUserCount, deleteDepartmentById } from '@/services/org/depart-service';
import { clone } from 'lodash';
export default {
  name: 'DeptTree',
  data() {
    return {
      loading: true,
      orgId: parseInt(this.$store.state.user.userInfo.orgId),
      userId: this.$store.state.user.userInfo.userid,
      departData: {},
      selectedDept: {},
      parentDeptName: '',
      isDisabled: ''
    };
  },
  created() {
    this.initUser();
    eventBus.$on('addOrEditDeptsuccess', () => {
      this.initUser();
    });
  },
  methods: {
    async initUser() {
      this.$root.layout.isLoading = true;
      this.isDisabled = true;
      try {
        let [{ data: data1 }, { data: data2 }] = await Promise.all([
          loadDepartment(this.orgId),
          loadDepartmentUserCount(this.orgId)
        ]);
        let departList = data1.department;
        let departUserCountList = data2.departUserCountList;
        if (departList.length > 0) {
          if (departUserCountList.length > 0) {
            for (let i = 0; i < departList.length; i++) {
              if (departList[i].departId === this.orgId) {
                this.selectedDept = departList[i];
                this.parentDeptName = departList[i].departName;
              }
              for (let j = 0; j < departUserCountList.length; j++) {
                if (departUserCountList[j]['DEPART_ID'] === departList[i]['departId']) {
                  departList[i].userCount = departUserCountList[j]['USER_COUNT'];
                }
              }
            }
          }
        }
        this.departData = departList;
        eventBus.$emit('selectDeptNode', this.selectedDept);
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    addDept: function() {
      eventBus.$emit('addDept', 'add', this.orgId, this.parentDeptName);
    },
    editDept: function() {
      let editDept = clone(this.selectedDept);
      eventBus.$emit('editDept', 'edit', editDept);
    },
    deleteDept: function() {
      this.$ebConfirm('确定要删除此部门吗?')
        .then(() => {
          this.deleteDeptConfirm();
        })
        .catch(() => {});
    },
    async deleteDeptConfirm() {
      try {
        let { data } = await deleteDepartmentById(this.selectedDept.departId);
        if (data.returnCode === '01') {
          this.$message.success('删除部门成功！');
          this.initUser();
        } else if (data.returnCode === '05') {
          this.$message.error('请先删除部门下所有用户再删除部门！');
        } else {
          this.$message.error('删除部门失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    },
    selectDept: function(depart) {
      this.selectedDept = depart;
      this.selectedDept.parentDeptName = this.parentDeptName;
      this.selectedDept.parentId = this.orgId;
      if (depart.departId === this.orgId) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
      eventBus.$emit('selectDeptNode', this.selectedDept);
    }
  },
  beforeDestroy() {
    eventBus.$off('addOrEditDeptsuccess');
  }
};
</script>
<style lang="less" scoped>
#DeptTree {
  padding-bottom: 15px;
  .deptTreeTitle {
    width: 100%;
    font-size: 20px;
    font-weight: bold;
    color: #fb5b3b;
    height: 38px;
    line-height: 38px;
  }
  .deptTreeButton {
    width: 100%;
    height: 22px;
    margin-top: 10px;
    button {
      width: 28%;
    }
  }
  .deptTreeData {
    background-color: white;
    border: 1px solid #ccc;
    min-height: 400px;
    margin-top: 15px;
    ul {
      padding-left: 10px;
      padding-right: 10px;
      li {
        cursor: pointer;
        list-style-type: none;
        margin-top: 2px;
        line-height: 18px;
        min-height: 18px;
        font-size: 15px;
      }
    }
    .selected {
      background-color: #fb5b3b;
    }
  }
}
</style>
